module.exports = __webpack_public_path__ + "img/5.7b00de72.png";